import { global } from "../../constants";

export const data = {
  slide: {
    title: "Soluciones Logísticas Integrales para Marinos Mercantes",
    subtitle:
      "Expertos en logística portuaria, asesorías técnicas y gestión de documentación marítima internacional.",
  },

  services: {
    tag: "Servicios",
    title: "Todos los servicios",
    subtitle: "Confiables por nuestros servicios",
    description:
      "Ofrecemos un portafolio completo de servicios, diseñados para cumplir con los más altos estándares de calidad. La confianza que nuestros clientes depositan en nosotros es el resultado directo de nuestra dedicación, profesionalismo y entrega consistente de excelencia.",
    services: [
      {
        image: global.sgallery + "1.jpg",
        title: "Derecho Marítimo",
        serial: "01",
        url_service: "/services/maritime-law",
        description:
          "Brindamos asesoría y asistencia legal especializada en Derecho Marítimo, ofreciendo soluciones integrales y a la medida para cada caso.",
      },
      {
        image: global.sgallery + "tributario.webp",
        title: "Derecho Tributario",
        serial: "02",
        url_service: "/services/tax-law",
        description:
          "Ofrecemos servicios de planificación fiscal y aduanera integral, comenzando por la identificación de su actividad económica y modelo de negocio.",
      },
      {
        image: global.sgallery + "aduanero.webp",
        title: "Derecho Aduanero",
        serial: "03",
        url_service: "/services/customs-law",
        description:
          "Analizamos su operación, identificamos normas aplicables y creamos estrategias para un cumplimiento, reducir riesgos y mejorar su desempeño.",
      },
      {
        image: global.sgallery + "mercantil.webp",
        title: "Derecho Mercantil",
        serial: "04",
        url_service: "/services/commercial-law",
        description:
          "Gestionamos la constitución de su empresa venezolana, realizamos todos los trámites legales y redactamos contratos mercantiles.",
      },
      {
        image: global.sgallery + "seguro.webp",
        title: "SEGUROS",
        serial: "05",
        url_service: "/services/insurance",
        description:
          "Determinamos los seguros y fianzas necesarios para su negocio, incluyendo protección patrimonial para comercio exterior y transporte, así como seguros personales corporativos.",
      },
      {
        image: global.sgallery + "administrivo.webp",
        title: "Procesos Administrativos",
        serial: "06",
        url_service: "/services/administrative-processes",
        description:
          "Actividades de gestión para coordinar la navegación, operaciones portuarias y comercio marítimo, garantizando seguridad y cumplimiento legal.",
      },
      {
        image: global.sgallery + "sts.webp", // la imagen la proporcionas tú
        title: "Operaciones STS",
        serial: "07",
        url_service: "/services/operations-sts",
        description:
          "Gestionamos de forma segura las operaciones Ship-to-Ship (STS) para transferencia de hidrocarburos y cargas líquidas, con cumplimiento regulatorio, gestión de riesgos y supervisión técnica especializada.",
      },
    ],
  },

  clients: {
    "title": "Nuestros Aliados",
    "logos": [
    {img: global.logo + "aras-shipping.webp", url: "https://arasshipping.us/"},
  ]},

  whychoosus: {
    title: "¿Por qué elegirnos?",
    subtitle: "Somos una agencia profesional de logística y carga",
    description:
      "Su socio estratégico en la cadena de suministro global, ofreciendo soluciones logísticas y de carga profesionales, eficientes y confiables.",
    branches: "200+",
    since: "Desde 2015",
    solutions: "Soluciones completas",
    specifications: [
      "Ir más allá de la logística, hacer que el mundo gire y revolucionar los negocios.",
      "Logística a través de la innovación, dedicación y tecnología. listo, preparado, hecho.",
      "Nos enorgullece servir a nuestros clientes de manera segura. juntos con pasión.",
      "La imaginación, lo que podemos ver fácilmente es solo un pequeño porcentaje.",
      "La calidad nunca pasa de moda. seguridad, calidad, profesionalismo.",
      "La calidad se muestra en cada movimiento que hacemos donde vive el negocio.",
    ],
  },

  approach: {
    title: "Enfoque de la empresa",
    subtitle: "Soluciones logísticas y de transporte confiables",
    yearsOfExperience: "10",
    slogan:
      "Años de experiencia como consultoría integral para negocios y comercio exterior.",
    specifications: [
      {
        icon: global.icons + "c-pic1.png",
        count: "10",
        title: "Personal profesional",
      },
      {
        icon: global.icons + "pic7.png",
        count: "80",
        title: "Operaciones STS",
      },
      {
        icon: global.icons + "c-pic3.png",
        count: "50",
        title: "Tecnología y medios",
      },
    ],
  },

  projects: {
    title: "Proyectos",
    subtitle: "Proyectos Destacados",
    description:
      "Nuestros proyectos más destacados incluyen la optimización fiscal para empresas navieras, la defensa legal en disputas marítimas internacionales y la implementación de seguros patrimoniales a la medida para grandes cargamentos, siempre garantizando seguridad jurídica y eficiencia.",
    readMore: "Leer más",
    projects: [
      {
        image: global.projects + "1.jpg",
        title: "Almacenamiento, Distribución",
        subtitle: "Inventario de almacén",
        caption: "",
      },
      {
        image: global.projects + "transfers.webp",
        title: "Procesos de Transferencia STS",
        subtitle: "Operaciones seguras y eficientes",
        caption: "",
      },
      {
        image: global.projects + "contents.webp",
        title: "Manejo de Contenedores",
        subtitle: "Mejores prácticas de carga",
        caption: "",
      },
      {
        image: global.projects + "4.jpg",
        title: "Almacenamiento, Distribución",
        subtitle: "Inventario de almacén",
        caption: "",
      },
      {
        image: global.projects + "clinsh.webp",
        title: "Inspecciones de Transferencia STS",
        subtitle: "Auditorias de seguridad",
        caption: "",
      },
      {
        image: global.projects + "6.jpg",
        title: "Almacenamiento, Distribución",
        subtitle: "Inventario de almacén",
        caption: "",
      },
    ],
  },
};
